import { createContext } from "react";

export const NavigationBarContext = createContext<{
  hidden: boolean;
  setHidden: (hidden: boolean) => void;
}>({
  hidden: false,
  setHidden: (_hidden: boolean) => {},
});
